import localforage from 'localforage';
import FJUtil from '../util/FJUtil';
import FJImageStore from './FJImageStore';
import FJNetworkStore from './FJNetworkStore';

const _localforage = localforage.createInstance({
    name: 'ai_mask_storage',
    version: 1.0,
    storeName: 'ai_mask_cache',
    description: 'ai mask store at local storage.',
});

const FJAiMaskStore = {
    /**
     * @desc 根据文件生成 aiMask 数据存储的 key
     * @param {Blob} blob
     * @returns {string} key
     */
    getAiMaskKeyByBlob: async function (blob) {
        const id = await FJUtil.hashEncode(blob);
        if (!id) return;
        return `mask_${id}`;
    },

    /**
     * @desc 获取本地存储的item
     * @param {string} key
     * @returns {Promise<string>} value
     */
    getLocalForageItem: async function (key) {
        return await _localforage.getItem(key);
    },

    /**
     * @desc 设置本地存储的item
     * @param {string} key
     * @param {string} value
     * @returns {Promise<void>}
     */
    setLocalForageItem: async function (key, value) {
        await _localforage.setItem(key, value);
    },

    /**
     * @desc 获取mask数据
     * @param {Blob} blob
     * @returns {Promise<string | null>} maskData
     */
    getMaskData: async function (blob) {
        try {
            const blobId = await this.getAiMaskKeyByBlob(blob);
            if (!blobId) return;

            let maskData = await this.getLocalForageItem(blobId);
            if (!maskData) {
                const s3Url = await FJImageStore.uploadFileByBlob(blob);
                if (!s3Url) return;

                const maskJsonUrl = await FJNetworkStore.getAiMask(s3Url);
                if (!maskJsonUrl) return;

                maskData = await fetch(maskJsonUrl).then(res => res.json());

                if (!maskData) return;
                this.setLocalForageItem(blobId, maskData);
            }

            return {
                maskData,
                id: blobId,
            };
        } catch (error) {
            return null;
        }
    },
};
export default FJAiMaskStore;
